(() => {
  const selector = '[data-sr-bundle-form]';
  const initialize = root => {
    if (root.dataset.srBundleReady) return;
    root.dataset.srBundleReady = 'true';
    const product = JSON.parse(root.dataset.product);
    const choices = Array.from(root.querySelectorAll('[data-sr-bundle-option]'));
    const master = root.querySelector('[data-variants]');
    const button = root.querySelector('[name="add"]');
    const message = root.querySelector('[data-sr-bundle-message]');
    const sync = () => {
      const complete = choices.every(choice => choice.value !== '');
      const variant = complete && product.variants.find(item => item.options.every((value, index) => value === choices[index].value));
      const available = Boolean(variant && variant.available);
      master.value = available ? String(variant.id) : '';
      master.disabled = !available;
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.classList.toggle('disabled', !available);
      button.querySelector('.text').textContent = available ? button.dataset.label : root.dataset.srChooseLabel;
      message.hidden = !complete || available;
      message.textContent = complete && !available ? root.dataset.srUnavailableLabel : '';
      return available;
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[data-sr-bundle-option]')) sync();
    });
    const guard = event => {
      if (event.type === 'click' && !event.target.closest('[name="add"]')) return;
      if (!sync()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const missing = choices.find(choice => !choice.value);
        if (missing) missing.focus();
      }
    };
    root.addEventListener('click', guard, true);
    root.addEventListener('submit', guard, true);
    window.addEventListener('pageshow', sync);
    sync();
  };
  const scan = root => {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.(selector)) initialize(root);
    root.querySelectorAll(selector).forEach(initialize);
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan)))
    .observe(document.body, { childList: true, subtree: true });
})();
